import { Flex } from 'antd'
import { BudgetCoinLoader } from 'src/pages/budget/components'
import {
  ModalAddUser,
  ModalDeleteUser,
  UnitCard,
} from 'src/pages/budget/budgetTeams/components'
import {
  useBudgetTeamList,
  useTeamListGate,
} from 'src/pages/budget/budgetTeams/hooks'

export const TeamSection = () => {
  useTeamListGate()
  const { teamsTree, loadingTeamList } = useBudgetTeamList()

  if (loadingTeamList) {
    return <BudgetCoinLoader />
  }

  return (
    <>
      <Flex vertical gap={24}>
        {teamsTree.map((team) => (
          <UnitCard key={team.id} team={team} />
        ))}
      </Flex>
      <ModalAddUser />
      <ModalDeleteUser />
    </>
  )
}
